export default __webpack_public_path__ + "static/media/yomafleet_least_to_buy.6eb6b1c4.png";